<template>
  <div>
    <vuetable ref="vuetable" :api-url="url" :httpOptions="options" :fields="fields" pagination-path="" @vuetable:pagination-data="onPaginationData"></vuetable>
    <div class="vuetable-pagination ui basic segment grid">
      <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
      <bulma-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></bulma-pagination>
    </div>
  </div>
</template>


<script>
import Vue from 'vue'
import UserActions from './UserActions'

Vue.component('user-actions', UserActions)
import Vuetable from 'vuetable-2/src/components/Vuetable'
import BulmaPagination from './BulmaPagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'

import url from '../utils/url'
import moment from 'moment'

export default {
  props: ["url"],
  components: {
    Vuetable, BulmaPagination, VuetablePaginationInfo
  },
  data() {
    return {
      isLoading: false,
      options: {
        headers: { 'Authorization': window.localStorage.getItem('biyadmin') },
      },
      fields: [
        {
          name: '__sequence',   // <----
          title: '#'
        },
        {
          name: 'updatedAt',
          title: 'Date',
          callback: 'formatDate|DD/MMM HH:mm'
        },
        {
          name: 'name',
          title: 'Name'
        },
        {
          name: 'phone',
          title: 'Phone'
        },
        {
          name: 'primaryChannel',
          title: 'Primary Channel'
        },
        {
          name: '__component:user-actions',   // <----
          title: 'Actions'
        }
      ]
    }
  },
  methods: {
    formatDate(value, fmt = 'D MMM YYYY') {
      return (value == null)
        ? ''
        : moment(value).format(fmt)
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page)
    }
  }
}
</script>


// WEBPACK FOOTER //
// UsersTable.vue?8baea858